<c-money-base-page [mode]="'new'" />
